<app-tab>
  <div *ngIf="!canView" class="p-8 text-center text-gray-500">
    <p class="text-lg font-medium">Vous n'avez pas la permission de voir les interventions reconstruites</p>
    <p class="text-sm mt-2">Contactez votre administrateur pour obtenir l'accès</p>
  </div>

  <app-reconstructed-interventions-toolbar *ngIf="canView" (generate)="load($event)" [grid]="grid"></app-reconstructed-interventions-toolbar>
  
  <!-- Manual Reconstruction Section -->
  <div *ngIf="canView && canGenerate" class="p-3 mb-3 bg-gray-50 border border-gray-200 rounded flex items-center justify-between">
    <div class="flex items-center space-x-4">
      <span class="text-sm font-medium text-gray-700">Reconstruction manuelle:</span>
      <dx-date-box
        [(value)]="reconstructDate"
        width="140"
        stylingMode="outlined"
        placeholder="Sélectionner une date">
      </dx-date-box>
      <dx-button
        text="Lancer la reconstruction"
        icon="refresh"
        type="default"
        (onClick)="reconstruct()">
      </dx-button>
    </div>
    <span class="text-xs text-gray-500">Génère les interventions reconstruites pour la date sélectionnée</span>
  </div>

  <dx-data-grid
    *ngIf="canView"
    #grid
    id="reconstructedInterventionsGridContainer"
    [ngStyle]="gridCss"
    [dataSource]="ds"
    [showRowLines]="true"
    [remoteOperations]="{ paging: true, sorting: true, filtering: true}"
    [allowColumnReordering]="true"
    [allowColumnResizing]="true"
    [rowAlternationEnabled]="true"
    [columnHidingEnabled]="false"
    [columnAutoWidth]="true"
    [errorRowEnabled]="false"
    [libGridTitle]="{text: 'Interventions Reconstruites'}"
    (onRowDblClick)="canViewReport ? showInterventionDetails($event) : null"
    [showBorders]="false">

    <dxi-column
      caption="ID"
      dataField="id"
      [allowEditing]="false"
      [formItem]="{visible: false}"
      dataType="number">
    </dxi-column>

    <dxi-column type="buttons" caption="Actions" [width]="200">
      <dxi-button
        *ngIf="canValidate"
        name="validate"
        [visible]="isPendingValidation"
        text="Valider"
        hint="Valider l'Intervention"
        [icon]="getValidateIcon()"
        [onClick]="validateIntervention"></dxi-button>
      <dxi-button
        *ngIf="canReject"
        name="reject"
        [visible]="isPendingValidation"
        text="Rejeter"
        hint="Rejeter l'Intervention"
        [icon]="getRejectIcon()"
        [onClick]="rejectIntervention"></dxi-button>
      <dxi-button
        *ngIf="canViewReport"
        name="details"
        hint="Détails"
        [icon]="getDetailsIcon()"
        [onClick]="showInterventionDetails"></dxi-button>
    </dxi-column>

    <dxi-column caption="Date et Heures">
      <dxi-column
        caption="Date"
        dataField="start_time"
        sortOrder="desc"
        format="shortDate"
        dataType="date">
      </dxi-column>

      <dxi-column
        caption="Début"
        dataField="start_time"
        format="shortTime"
        dataType="date">
      </dxi-column>

      <dxi-column
        caption="Fin"
        dataField="stop_time"
        format="shortTime"
        dataType="date">
      </dxi-column>
    </dxi-column>

    <dxi-column
      caption="Type"
      [width]="120"
      dataField="intervention_type"
      [calculateCellValue]="getInterventionTypeLabel.bind(this)"
      [calculateDisplayValue]="getInterventionTypeLabel.bind(this)">
    </dxi-column>

    <dxi-column caption="Domaine">
      <dxi-column caption="Nom" dataField="domain_name"></dxi-column>
      <dxi-column caption="BU" dataField="business_unit_name"></dxi-column>
    </dxi-column>

    <dxi-column caption="Parcelle">
      <dxi-column
        caption="Nom"
        dataField="field.name">
      </dxi-column>
      <dxi-column
        caption="Superficie"
        [width]="100"
        [customizeText]="hectareUnit"
        dataField="field.polygon_area">
      </dxi-column>
      <dxi-column
        caption="Superficie Travaillée"
        dataType="number"
        format="#0.## Ha"
        dataField="working_area_ha">
      </dxi-column>
      <dxi-column
        caption="Percentage"
        dataType="number"
        format="percent"
        [width]="100"
        dataField="working_area_percent">
      </dxi-column>
    </dxi-column>

    <dxi-column caption="Tracteur">
      <dxi-column
        caption="Nom"
        dataField="tractor_name">
      </dxi-column>
      <dxi-column
        caption="Outil"
        dataField="trailer_name">
      </dxi-column>
      <dxi-column
        caption="Largeur"
        [width]="80"
        [customizeText]="widthUnit"
        dataField="trailer_width">
      </dxi-column>
    </dxi-column>

    <dxi-column caption="Durée (H:m)">
      <dxi-column caption="Totale" dataField="total_duration" cellTemplate="tmp"
                  [width]="80">
        <span *dxTemplate="let d of 'tmp'"
              style="border-bottom: 1px dotted;" [title]="durationToHoursStr(d)">{{durationToStr(d)}}</span>
      </dxi-column>
      <dxi-column caption="Totale Travail" dataField="total_working_duration" cellTemplate="tmp"
                  [width]="120">
        <span *dxTemplate="let d of 'tmp'"
              style="border-bottom: 1px dotted;" [title]="durationToHoursStr(d)">{{durationToStr(d)}}</span>
      </dxi-column>
      <dxi-column caption="Arrêt Travail" dataField="stop_working_duration" cellTemplate="tmp"
                  [width]="120">
        <span *dxTemplate="let d of 'tmp'"
              style="border-bottom: 1px dotted;" [title]="durationToHoursStr(d)">{{durationToStr(d)}}</span>
      </dxi-column>
      <dxi-column caption="Totale Trajet" dataField="total_road_duration" cellTemplate="tmp"
                  [width]="120">
        <span *dxTemplate="let d of 'tmp'"
              style="border-bottom: 1px dotted;" [title]="durationToHoursStr(d)">{{durationToStr(d)}}</span>
      </dxi-column>
    </dxi-column>

    <dxi-column caption="Vitesse">
      <dxi-column
        caption="Moyenne (km/h)"
        dataType="number"
        format="#0.##"
        dataField="working_in_field_speed_avg">
      </dxi-column>

      <dxi-column
        caption="Maximale (km/h)"
        dataType="number"
        format="#0.##"
        dataField="working_in_field_speed_max">
      </dxi-column>

      <dxi-column
        caption="Débit (Ha/h)"
        dataType="number"
        format="#0.##"
        dataField="working_hectare_per_hour">
      </dxi-column>
    </dxi-column>

    <dxi-column caption="Carburant">
      <dxi-column
        caption="Totale (L)"
        dataType="number"
        format="#0.##"
        dataField="total_fuel_consumption">
      </dxi-column>

      <dxi-column
        caption="Par Hectare (L/Ha)"
        dataType="number"
        format="#0.##"
        dataField="fuel_consumption_per_hectare">
      </dxi-column>
    </dxi-column>

    <dxi-column
      caption="Statut"
      [width]="120"
      dataField="status">
    </dxi-column>

    <dxi-column
      caption="Score"
      [width]="80"
      dataField="confidence_score">
    </dxi-column>

    <dxi-column
      caption="Note de Validation"
      [width]="140"
      cellTemplate="accuracyRatingTemplate"
      dataField="accuracy_rating">
      <div *dxTemplate="let cellInfo of 'accuracyRatingTemplate'">
        <lib-badge *ngIf="cellInfo.value" [color]="getAccuracyRatingColor(cellInfo.value)">{{cellInfo.value}}/10</lib-badge>
      </div>
    </dxi-column>

    <dxi-column
      caption="Raison de Rejet"
      [width]="200"
      cellTemplate="rejectionReasonTemplate"
      dataField="rejection_reason">
      <div *dxTemplate="let cellInfo of 'rejectionReasonTemplate'">
        <lib-badge *ngIf="cellInfo.value" color="red">{{cellInfo.value}}</lib-badge>
      </div>
    </dxi-column>

    <dxo-summary>
      <dxi-total-item
        column="working_area_ha"
        valueFormat="#0.##"
        summaryType="sum">
      </dxi-total-item>
      <dxi-total-item
        column="working_area_percent"
        valueFormat="percent"
        summaryType="sum">
      </dxi-total-item>
      <dxi-total-item
        column="total_duration"
        [customizeText]="durationToStr"
        summaryType="sum">
      </dxi-total-item>
      <dxi-total-item
        column="total_working_duration"
        [customizeText]="durationToStr"
        summaryType="sum">
      </dxi-total-item>
      <dxi-total-item
        column="stop_working_duration"
        [customizeText]="durationToStr"
        summaryType="sum">
      </dxi-total-item>
      <dxi-total-item
        column="total_road_duration"
        [customizeText]="durationToStr"
        summaryType="sum">
      </dxi-total-item>
      <dxi-total-item
        column="working_in_field_speed_max"
        valueFormat="#0.##"
        summaryType="max">
      </dxi-total-item>
      <dxi-total-item
        column="working_in_field_speed_avg"
        valueFormat="#0.##"
        summaryType="avg">
      </dxi-total-item>
      <dxi-total-item
        column="working_hectare_per_hour"
        valueFormat="#0.##"
        summaryType="avg">
      </dxi-total-item>
      <dxi-total-item
        column="total_fuel_consumption"
        valueFormat="#0.##"
        summaryType="sum">
      </dxi-total-item>
      <dxi-total-item
        column="fuel_consumption_per_hectare"
        valueFormat="#0.##"
        summaryType="avg">
      </dxi-total-item>
    </dxo-summary>

    <dxo-selection
      selectAllMode="page"
      mode="multiple"
    ></dxo-selection>

    <dxo-column-chooser [enabled]="true" mode="select"></dxo-column-chooser>

    <dxo-group-panel [visible]="false"></dxo-group-panel>

    <dxo-export [enabled]="true" fileName="liste-interventions-reconstruites"
                [allowExportSelectedData]="true"></dxo-export>

    <dxo-sorting mode="multiple"></dxo-sorting>

    <dxo-paging [pageSize]="25"></dxo-paging>

    <dxo-pager
      [showPageSizeSelector]="true"
      [allowedPageSizes]="[25, 50, 100]"
      [showInfo]="true">
    </dxo-pager>

    <dxo-filter-row [visible]="true"></dxo-filter-row>

    <dxo-search-panel
      [visible]="true"
      [width]="240"></dxo-search-panel>

    <dxo-header-filter [visible]="true"></dxo-header-filter>
  </dx-data-grid>
</app-tab>

<app-reconstructed-intervention-report
  [(visible)]="reportVisible"
  [intervention]="selectedIntervention"
  [request]="request"
  (onActionSuccess)="onReportActionSuccess()">
</app-reconstructed-intervention-report>

<app-validate-dialog
  #validateDialog
  (onValidate)="onValidateSuccess()">
</app-validate-dialog>

<app-reject-dialog
  #rejectDialog
  (onReject)="onRejectSuccess()">
</app-reject-dialog>

